// extracted by mini-css-extract-plugin
module.exports = {"siderCollapsedWidth":"40px","formItemCol":"formItemCol--3WKoX","labelInfo":"labelInfo--POOSD","actionButton":"actionButton--66qTT"};